import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
export default function ProtectedRoute({ component: Component, ...rest }) {
  const Data = useSelector((state) => state?.access_token);

  if (Data && Data !== null) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
    // return <Component  />;
  } else {
    return <Redirect to="/login" />;
  }
}
